import Swiper, { Pagination, EffectFade, Autoplay } from 'swiper';
import gsap from 'gsap';

$(document).ready(function() {
    const swiper = new Swiper('.hero-slideshow', {
        slidesPerView: 1,
        speed: 3500,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        loop: true,
        spaceBetween: 0,
        autoplay: {
            delay: 6000
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        modules: [Pagination, EffectFade, Autoplay],
        on: {
            slideChangeTransitionStart: function(s) {
                const animationDuration = 1.5;
                const slideAnimationElements = '.slide__label, .slide__heading, .slide__description, .slide__cta';
                const contentSelector = '.slide__content';
                const staggerRate = 0.15;
                const translate = 60;

                // OUT
                const lastSlide = s.slides[s.activeIndex - 1];
                const lastContentElements = Array.from(lastSlide.querySelectorAll(slideAnimationElements)).reverse();
                gsap.fromTo(lastContentElements, { y: 0, opacity: 1 }, { y: translate * 1.5, opacity: 0, duration: animationDuration / 1.5, stagger: staggerRate, ease: 'power3.in'});

                // IN
                const nextSlide = s.slides[s.activeIndex];
                const nextSlideContent = nextSlide.querySelector(contentSelector);
                const nextContentElements = Array.from(nextSlide.querySelectorAll(slideAnimationElements)).reverse();
                gsap.fromTo(nextSlideContent, {skewY: -3}, {skewY: 0, duration: animationDuration, delay: animationDuration, ease: 'power4.out'});
                gsap.fromTo(nextContentElements, { y: -translate, opacity: 0 }, { y: 0, opacity: 1, duration: animationDuration, stagger: staggerRate, delay: animationDuration, ease: 'power4.out'});
            }
        }
    });
});
